import { supabaseCirculoAnimal } from '../config/settings/supabase-client'
import factoryService from '../core/requests-supabase/services'

/**
 * Gets the list of projects.
 */
export const getProjects = factoryService(async () => {
  const data = await supabaseCirculoAnimal
    .from('project')
    .select('*')
    .eq('is_active', true)
    .order('sort_order', { ascending: true })

  return data
});
